/* eslint-disable react/require-default-props */
import React from 'react';
export function SideDrawerFooter({ children, className = '' }) {
    const footerClasses = ['qmb-ui-side-drawer-footer', className].filter(Boolean).join(' ');
    return (React.createElement("div", { className: footerClasses, role: "contentinfo" }, children));
}
